/**
 * Front page: logo in hero-section__bg-wrap — staggered vs robot (image-only hero):
 * Scroll down: robot hides first, then logo shows shortly after Features leaves Hero (not on 3rd section).
 * Scroll up: logo hides first (only when scrolling up), then robot (deferred in hero.js).
 */
(function () {
	'use strict';

	// After Hero: show logo once Features top is slightly above this line (small gap after robot IO)
	var LOGO_SHOW_DOWN_RATIO = 0.08;
	// Scroll up only: hide logo while Features still partly visible before Hero
	var LOGO_HIDE_UP_RATIO = 0.32;

	var logoWrap = document.querySelector('.front-page .hero-section__bg-logo-wrap');
	if (!logoWrap) {
		return;
	}

	var target =
		document.getElementById('features-section') ||
		document.querySelector('.front-page .front-page__below-hero-sentinel');
	if (!target) {
		return;
	}

	var lastVisible = null;
	var lastFeaturesTop = null;

	function setLogoVisible(visible) {
		if (visible) {
			logoWrap.classList.remove('hero-section__bg-logo-wrap--hidden');
			logoWrap.classList.add('hero-section__bg-logo-wrap--visible');
		} else {
			logoWrap.classList.add('hero-section__bg-logo-wrap--hidden');
			logoWrap.classList.remove('hero-section__bg-logo-wrap--visible');
		}
	}

	function computeVisible(entry) {
		var rect = entry.boundingClientRect;
		var vh = window.innerHeight || document.documentElement.clientHeight || 800;
		var scrollingUp = lastFeaturesTop !== null && rect.top > lastFeaturesTop + 0.5;
		lastFeaturesTop = rect.top;

		if (rect.bottom < 0) {
			return true;
		}
		if (rect.top >= vh) {
			return false;
		}

		var hideUpThreshold = vh * (1 - LOGO_HIDE_UP_RATIO);
		if (scrollingUp && rect.top > hideUpThreshold) {
			return false;
		}

		var showDownThreshold = vh * (1 - LOGO_SHOW_DOWN_RATIO);
		if (rect.top < showDownThreshold) {
			return true;
		}
		// Scrolling down: band between Hero and strict show line — show as soon as Features intersects
		if (!scrollingUp && entry.isIntersecting) {
			return true;
		}
		return false;
	}

	function applyVisible(next) {
		if (lastVisible !== null && next !== lastVisible) {
			if (lastVisible && !next) {
				if (typeof window.evonaHeroAfterLogoHiddenOnScrollUp === 'function') {
					window.evonaHeroAfterLogoHiddenOnScrollUp();
				}
			} else if (!lastVisible && next) {
				if (typeof window.evonaHeroCancelRobotReveal === 'function') {
					window.evonaHeroCancelRobotReveal();
				}
			}
		}
		lastVisible = next;
		setLogoVisible(next);
	}

	var observer = new IntersectionObserver(
		function (entries) {
			for (var i = 0; i < entries.length; i++) {
				applyVisible(computeVisible(entries[i]));
				return;
			}
		},
		{ threshold: [0, 0.01, 0.05, 0.1, 0.25] }
	);

	observer.observe(target);
})();
